import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { ParentalPinType } from '@kaltura-ott/tvpil-shared';

import MainLayout from 'components/presenters/layouts/main/MainLayout';
import Loader from 'components/presenters/Loader/Loader';
import PinCodeModal from 'components/widgets/Modal/PinCodeModal/PinCodeModal';
import { PinCodeModalTypes } from 'components/widgets/Modal/PinCodeModal/PinCodeModalTypesEnum';
import { useModalContext } from 'context/modal/modal';
import { useLoadingPerformanceEvents,useParentalPinStore } from 'hooks';

import { COMPONENT_NAME } from '../../constants';
import { usePackageDetailsContent } from '../PackageDetailsProvider/PackageDetailsProvider';
import PackageDetailsStateDefaultView from '../PackageDetailsStates/PackageDetailsStateDefaultView';
import PackageDetailsStateStatusView from '../PackageDetailsStates/PackageDetailsStateStatusView';

import styles from '../../PackageDetails.module.scss';

function PackageDetailsResolveRendering() {
  const {
    handleButtonBack,
    imageResolve,
    isChangeState,
    isRestricted,
    loading,
    subscription,
    title,
  } = usePackageDetailsContent();
  const intl = useIntl();
  const parentalControlStore = useParentalPinStore();
  const modalContext = useModalContext();
  const buttonLabel = intl.formatMessage({ defaultMessage: 'Back', id: `${COMPONENT_NAME}.purchaseButtonBack` });

  useEffect(() => {
    if (isRestricted && subscription) {
      const validateAdultSubscription = (pin: string) =>
        parentalControlStore.validatePin(pin, ParentalPinType.adult, subscription);

      modalContext.openModal(
        <PinCodeModal
          onDecline={handleButtonBack}
          context={UIDAPresentationTypeEnum.transaction_history}
          type={PinCodeModalTypes.RestrictedContent}
          validatePin={validateAdultSubscription}
        />,
      );
    }
  }, []);

  useLoadingPerformanceEvents(COMPONENT_NAME, loading);

  return (
    <MainLayout>
      {!isRestricted && (
        <div className={styles.wrapper}>
          <div className={styles.image}>{imageResolve && <img alt='poster' src={imageResolve} />}</div>
          <div className={styles.details}>
            <button className={styles.buttonBack} onClick={handleButtonBack} aria-label={buttonLabel} type='button'>
              { buttonLabel }
            </button>
            <div className={styles.titleWrapper}>
              <h1 className={styles.title}>
                {title.substring(0, 35)}
                <span className={styles.titleInfo}>
                  {/* TODO this is a temporary solution */}
                  {isChangeState &&
                    intl.formatMessage({ defaultMessage: 'yearly subscription', id: `${COMPONENT_NAME}.purchaseYearlySubscriptionTitle` })
                  }
                </span>
              </h1>
            </div>
            {loading && (
              <div>
                <Loader />
              </div>
            )}
            {isChangeState ? <PackageDetailsStateStatusView /> : <PackageDetailsStateDefaultView />}
          </div>
        </div>
      )}
    </MainLayout>
  );
}

export default PackageDetailsResolveRendering;
